// extracted by mini-css-extract-plugin
export default {"giftOrPromoRowWrapper":"Os-z","giftOrPromoSelector":"Ps-z","disabled":"Qs-z","subTitle":"Rs-z","selectShipAddressMessage":"Ss-z","changePayment":"Ts-z"};